import { render } from "./VideoElement.vue.js?vue&type=template&id=56883420!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElement.vue?vue&type=template&id=56883420"
import script from "./VideoElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElement.vue?vue&type=script&lang=js"
export * from "./VideoElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/video-element/VideoElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56883420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56883420', __exports__)) {
    api.reload('56883420', __exports__)
  }
  
  module.hot.accept("./VideoElement.vue.js?vue&type=template&id=56883420!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoElement.vue?vue&type=template&id=56883420", () => {
    api.rerender('56883420', render)
  })

}


export default __exports__